import type { AttendanceEnumsEmployeeTypeEnum } from 'generated/resources/graphql'

import { AmplitudeProps, EMPLOYEE_TYPE } from './types'

export const getTrackingOrigin = (
  employeeType: AttendanceEnumsEmployeeTypeEnum | undefined
): string | undefined => {
  if (!employeeType) return undefined
  return employeeType === EMPLOYEE_TYPE.PART_TIME
    ? AmplitudeProps.Origin.ComplementaryHours
    : AmplitudeProps.Origin.ExtraHours
}
